/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ForceForfeitBody
 */
export interface ForceForfeitBody {
    /**
     * ID of team being forced to forfeit
     * @type {string}
     * @memberof ForceForfeitBody
     */
    forfeitingTeamId: string;
    /**
     * Reason for forced forfeit
     * @type {string}
     * @memberof ForceForfeitBody
     */
    reason: string;
    /**
     * Optional optimistic locking version. If provided and doesn't match current tournament version, request fails with 409.
     * @type {number}
     * @memberof ForceForfeitBody
     */
    expectedVersion?: number;
}

/**
 * Check if a given object implements the ForceForfeitBody interface.
 */
export function instanceOfForceForfeitBody(value: object): value is ForceForfeitBody {
    if (!('forfeitingTeamId' in value) || value['forfeitingTeamId'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function ForceForfeitBodyFromJSON(json: any): ForceForfeitBody {
    return ForceForfeitBodyFromJSONTyped(json, false);
}

export function ForceForfeitBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForceForfeitBody {
    if (json == null) {
        return json;
    }
    return {
        
        'forfeitingTeamId': json['forfeitingTeamId'],
        'reason': json['reason'],
        'expectedVersion': json['expectedVersion'] == null ? undefined : json['expectedVersion'],
    };
}

export function ForceForfeitBodyToJSON(json: any): ForceForfeitBody {
    return ForceForfeitBodyToJSONTyped(json, false);
}

export function ForceForfeitBodyToJSONTyped(value?: ForceForfeitBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'forfeitingTeamId': value['forfeitingTeamId'],
        'reason': value['reason'],
        'expectedVersion': value['expectedVersion'],
    };
}

